import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col, Spinner } from 'react-bootstrap';
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorRedHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorRedHover};

    svg {
      fill: ${colorRedHover};
    }
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const SubscriptionList = (props) => {
    const [showLoader, setShowLoader] = useState(true);
    const [subscriptionsList, setSubscriptionsList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isSortable: true,
        withPagination: true,
        withSearchEngine: true,
        placeholder: 'Search...',
    };

    const handleEdit = (subscription_id) => {
        props.setEditSubscriptionIdHandler(subscription_id)
    }

    const GetSubscriptions = () => {
        setShowLoader(true);
        AdminInterface.instance.getSubscriptions().then((response) => {
            const columns = [
                {
                    accessor: 'display_name',
                    Header: 'Display Name'
                },
                {
                    accessor: 'subscription',
                    Header: 'Subscription Plan',
                    disableSortBy: true
                },
                {
                    accessor: 'expiry_datetime',
                    Header: 'Expiry',
                    disableSortBy: true
                },
                {
                    accessor: 'edit',
                    Header: 'Edit',
                    disableGlobalFilter: true,
                    disableSortBy: true
                }
            ];
            const data = [];
            response.data.forEach(subscription => {
                data.push({
                    display_name: subscription.organization.display_name,
                    subscription: subscription.subscription,
                    expiry_datetime: subscription.expiry_datetime,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(subscription.organization_id)}><EditIcon /></CartTableButton>
                });
            });

            const subscriptionListTableData = { tableHeaderData: columns, tableRowsData: data };
            setSubscriptionsList(subscriptionListTableData);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        }).finally(() => {
            setShowLoader(false);
            props.setListRequiresReload(false);
        })
    };

    useEffect(() => {
        GetSubscriptions();
    }, [props.listRequiresReload]);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Subscription List</CardTitle>
                    </CardTitleWrap>
                    {
                        !showLoader &&
                        <ReactTableBase columns={subscriptionsList.tableHeaderData} data={subscriptionsList.tableRowsData} tableConfig={tableConfig} />
                    }
                    {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
                </CardBody>
            </Card>
        </Col>
    );
};

SubscriptionList.propTypes = {
    subscriptionListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default SubscriptionList;